export default __webpack_public_path__ + "locales/zh-CN/Common.json?hash=5359f2ed226d712045433924e2d427c0";